import { Button, Col, Form, Input, Row, Select, Space } from 'antd';
import { useState } from 'react';

const { Option } = Select;

interface RegisterFAComponent3Props {
  clientType: string;
  organizationCode: string;
  onPrev: () => void;
  onNext: (data: any) => void;
}

function RegisterFAComponent3({
  clientType,
  organizationCode,
  onPrev,
  onNext,
}: RegisterFAComponent3Props) {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  return (
    <>
      <Form
        name="basic"
        form={form}
        layout="vertical"
        onFinish={() => {
          form
            .validateFields()
            .then(async (values) => {
              setIsLoading(true);
              await onNext(values);
              setIsLoading(false);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="id"
              label="아이디"
              rules={[
                {
                  required: true,
                  message: '아이디를 입력 하세요.',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="password"
              label="비밀번호"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력 하세요.',
                },
              ]}
            >
              <Input.Password placeholder="새 비밀번호" />
            </Form.Item>
          </Col>
        </Row>

        {/* 신한/롯데 법인카드의 경우 */}
        {clientType === '1' &&
          (organizationCode === '0306' || organizationCode === '0311') && (
            <Row justify={'center'}>
              <Col span={18}>
                <Form.Item
                  name="loginTypeLevel"
                  label="로그인 구분"
                  rules={[
                    {
                      required: true,
                      message: '로그인 구분을 선택하세요.',
                    },
                  ]}
                >
                  <Select>
                    <Option value="0">이용자</Option>
                    <Option value="1">사업장/부서관리자</Option>
                    <Option value="2">총괄관리자</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}

        {/* 신한 법인카드의 경우 */}
        {clientType === '1' && organizationCode === '0306' && (
          <Row justify={'center'}>
            <Col span={18}>
              <Form.Item
                name="clientTypeLevel"
                label="의뢰인 구분"
                rules={[
                  {
                    required: true,
                    message: '로그인 구분을 선택하세요.',
                  },
                ]}
              >
                <Select>
                  <Option value="0">신용카드회원</Option>
                  <Option value="1">체크카드회원</Option>
                  <Option value="2">연구비신용카드회원</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row justify="center" style={{ marginTop: '50px' }}>
          <Col span={18}>
            <Form.Item>
              <Row justify="center">
                <Space size="middle">
                  <Button htmlType="button" onClick={onPrev}>
                    뒤로
                  </Button>
                  <Button type="primary" htmlType="submit" loading={isLoading}>
                    로그인
                  </Button>
                </Space>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default RegisterFAComponent3;
